import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'usimweb-button-navigate',
    template: `
    <button
      *ngIf="navigateAction === 'previous'"
      (click)="clicked()"
      type="button"
      class="btn-space"
      mat-stroked-button
      matStepperPrevious
    >
      {{ text }}
    </button>
    <button
      *ngIf="navigateAction === 'next'"
      (click)="clicked()"
      type="button"
      class="btn-space"
      mat-stroked-button
      matStepperNext
    >
      {{ text }}
    </button>
    <button *ngIf="navigateAction === 'none'" (click)="clicked()" type="button" class="btn-space" mat-stroked-button>
      {{ text }}
    </button>
  `,
    standalone: false
})
export class ButtonNavigateComponent {
  @Input() text!: string;
  @Input() navigateAction!: 'previous' | 'next' | 'none';
  @Output() btnClick: EventEmitter<any> = new EventEmitter();

  public clicked() {
    this.btnClick.emit();
  }
}
